import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './Footer.css';
import geedopLogo from '../img/logo-bot-blugra.png';
import geedopLogoD from '../img/logo-bot-blugda.png';

export default function Footer() {
  const [year, setYear] = useState('2023');

  useEffect(() => {
    const onLoad = async() => {
      var pYear = new Date().getFullYear()
      setYear(pYear);
    }
    const onUnload = async() => {
      
    }
    onLoad();
    return () => {
      // Anything in here is fired on component unmount.
      onUnload();
    }
  }, []);

  return (
    <div fluid="true" className="Footer">
      <Container>
        <Row>
          <Col sm={8} className="left">
            <ul className="list-inline">

            </ul>
          </Col>
          <Col sm={4} className="right">

          </Col>
        </Row>
      </Container>
      <Container>
        <Row>
          <Col sm={8} className="left">
            <ul className="list-inline">
               <li className="list-inline-item"><a href="https://www.geedop.com" rel="noreferrer" target="_blank"><span>&copy; 2011-{year} Geedop, LLC</span></a></li>
               <li className="list-inline-item">|</li>
               <li className="list-inline-item"><a href="https://www.geedop.com/terms" rel="noreferrer" target="_blank">Terms</a></li> 
               <li className="list-inline-item"><a href="https://www.geedop.com/privacy" rel="noreferrer" target="_blank">Privacy</a></li> 
               <li className="list-inline-item"><a href="https://www.geedop.com/connect" rel="noreferrer" target="_blank">Connect</a></li> 
            </ul>
          </Col>
          <Col sm={4} className="right">
            <ul className="list-inline">
              <li className="list-inline-item">
                <a href="https://www.geedop.com" rel="noreferrer" target="_blank">
                  <img className="geedop-logo" src={(window.location.pathname === "/" || window.location.pathname.includes('company')) ? geedopLogo : geedopLogoD} alt="" />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </div>
  );
}



